import { render } from "./NewUserModal.vue?vue&type=template&id=24c6973e"
import script from "./NewUserModal.vue?vue&type=script&lang=js"
export * from "./NewUserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/modals/NewUserModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24c6973e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24c6973e', __exports__)) {
    api.reload('24c6973e', __exports__)
  }
  
  module.hot.accept("./NewUserModal.vue?vue&type=template&id=24c6973e", () => {
    api.rerender('24c6973e', render)
  })

}


export default __exports__